import { OptionType } from '@/typings/common';

import { AlfaLeasingQuizFieldsType } from './components/AlfaLeasingQuiz/types';
import { AlfaLeasingFormFields } from './components/AlfaLeasingForm/types';

export enum AlfaLeasingFormState {
  LeasingIntro = 'LEASING_INTRO',
  LeasingQuiz = 'LEASING_QUIZ',
  LeasingForm = 'LEASING_FORM',
}

export type AlfaLeasingFormViewProps =
  | {
      state: AlfaLeasingFormState.LeasingIntro;
      props: {
        onClose: () => void;
        onNextStep: () => void;
      };
    }
  | {
      state: AlfaLeasingFormState.LeasingQuiz;
      props: {
        onSubmitAlfaLeasingQuiz?: (
          values: AlfaLeasingQuizFieldsType
        ) => Promise<void>;
        onClose: () => void;
      };
    }
  | {
      state: AlfaLeasingFormState.LeasingForm;
      props: {
        onSubmitAlfaLeasingForm?: (
          values: AlfaLeasingFormFields
        ) => Promise<void>;
        onClose: () => void;
        dealers: OptionType[];
        isApproved: boolean;
      };
    };
